var _polyline, _line, _polyline2, _line2, _line3, _path, _line4, _line5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorTerrace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "2.672 25.225 4.914 31.605 10.605 31.605 12.76 37.727"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.672,
    y1: 37.727,
    x2: 4.914,
    y2: 31.605
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "39.328 25.225 37.086 31.605 31.395 31.605 29.24 37.727"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 39.328,
    y1: 37.727,
    x2: 37.086,
    y2: 31.605
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 21.145,
    y1: 37.727,
    x2: 21.145,
    y2: 14.447
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m36.326,14.447H5.965c-.521,0-.943-.422-.943-.943v-.795c0-.361.206-.69.531-.848l15.593-7.588,15.593,7.588c.325.158.531.487.531.848v.795c0,.521-.422.943-.943.943Z"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 29.983,
    y1: 26.087,
    x2: 12.308,
    y2: 26.087
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 24.465,
    y1: 37.296,
    x2: 17.826,
    y2: 37.296
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorTerrace);
export default __webpack_public_path__ + "static/media/indoor-terrace.a68add3ca43e26e66f1e3d542feb24ce.svg";
export { ForwardRef as ReactComponent };